import React from "react"
import { cn } from "utils/classnames"

type Props = React.HTMLAttributes<HTMLDivElement> & {
    children: React.ReactNode
    className?: string
    as?: React.ElementType
}

export const Flex = ({ as = "div", children, className, ...props }: Props) => {
    const Component = as
    return (
        <Component className={cn("flex", className)} {...props}>
            {children}
        </Component>
    )
}
